export default __webpack_public_path__ + "static/media/hayashizaki_bright_crop.854c6be0.jpg";